module.exports = __webpack_public_path__ + "img/chinesecompany02.780aed74.png";